import React from "react";
import PropTypes from "prop-types";
import "./style.css";

const RadioInput = ({
  id,
  name,
  value,
  checked,
  onChange,
  label,
  disabled = false,
}) => {
  return (
    <div className="radio-input">
      <input
        type="radio"
        id={id}
        name={name}
        value={value}
        checked={checked}
        onChange={onChange}
        disabled={disabled}
      />
      <label htmlFor={id}>{label}</label>
    </div>
  );
};

RadioInput.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  checked: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  label: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
};

export default RadioInput;
